import { createElement, useState, useEffect, Fragment } from "react";
export function useMounted() {
  var _a = useState(false),
      mounted = _a[0],
      setMounted = _a[1];

  useEffect(function () {
    setMounted(true);
  }, []);
  return mounted;
}
export var ClientOnly = function ClientOnly(_a) {
  var children = _a.children,
      placeholder = _a.placeholder;
  var mounted = useMounted();

  if (!mounted) {
    return createElement(Fragment, {
      children: placeholder
    }) || null;
  }

  return createElement(Fragment, {
    children: children
  });
};